import React from 'react'
import Main from '../../../components/HOC/Main'

export default function UploadJobPage() {
  return (
    <Main>
        <div>UploadJobPage</div>
    </Main>
  )
}
